import i18n from "i18next";
import { getIntlLocale } from "util/locale";
import { apiRequest } from "util/services";

/**
 * @returns {Promise<{ purchases: object[], total: number }|null>}
 */
export async function fetchPurchaseHistory(params = {}) {
  const res = await apiRequest(
    "subscriptions/purchases/history",
    "POST",
    {
      limit: params.limit ?? 20,
      offset: params.offset ?? 0,
      ...(params.productKey ? { product_key: params.productKey } : {}),
    },
    true,
  );
  if (res?.success) {
    return {
      purchases: res.success.purchases ?? [],
      total: res.success.total ?? 0,
    };
  }
  return null;
}

const PRODUCT_LABELS = {
  alert_addon: "settings.plan_purchase_product_alert_addon",
  extra_dashboards: "settings.plan_purchase_product_extra_dashboards",
};

const EVENT_LABELS = {
  purchase_attempt: "settings.plan_purchase_event_attempt",
  subscribed: "settings.plan_purchase_event_subscribed",
  initial_payment: "settings.plan_purchase_event_initial_payment",
  renewed: "settings.plan_purchase_event_renewed",
  payment_succeeded: "settings.plan_purchase_event_payment",
  canceled: "settings.plan_purchase_event_canceled",
  status_changed: "settings.plan_purchase_event_status_changed",
  payment_failed: "settings.plan_purchase_event_payment_failed",
  reactivated: "settings.plan_purchase_event_reactivated",
  one_off_purchase: "settings.plan_purchase_event_one_off",
};

export function formatPurchaseProductKey(productKey, t) {
  const key = PRODUCT_LABELS[productKey];
  return key ? t(key) : productKey;
}

export function formatPurchaseEventType(eventType, t) {
  const key = EVENT_LABELS[eventType];
  return key ? t(key) : eventType;
}

export function formatPurchaseAmount(amountCents, currency) {
  if (amountCents == null) return "—";
  const value = (Number(amountCents) / 100).toLocaleString(getIntlLocale(i18n.language), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return currency ? `${value} ${String(currency).toUpperCase()}` : value;
}
